import React from "react";
import { Paragraph, Tooltip } from "@tvg/design-system";
import { AmountCellProps } from "../types";
import { getFormattedAmount } from "../functions";
import { TOOLTIP_TRIGGER_NUM } from "../constants";

const AmountDisplay = ({ amount }: AmountCellProps) => {
  // If amount it undefined or if it is 0.0
  // We are receiving a float as a string from the backend
  if (amount === undefined || amount === null || amount === "0.0") return "-";

  // We get the formatted amount as a currency
  const formattedAmount = getFormattedAmount(amount, 0);

  // We convert the float amount (coming as a string) to an int and check if we have less than 5 digits
  // So numbers below the trigger number wont be displayed with a tooltip
  if (parseInt(amount, 10) < TOOLTIP_TRIGGER_NUM) return formattedAmount;

  return (
    <Tooltip
      qaLabel="probables-amount-tooltip"
      content={formattedAmount}
      key={`tooltip-${Math.random().toString()}`}
    >
      <Paragraph qaLabel="probables-amount-truncated">
        {getFormattedAmount(amount, 0, true)}
      </Paragraph>
    </Tooltip>
  );
};

export default AmountDisplay;
